export const DIALOG_TRADE_REQUEST_KEY = "tradeRequest";
export const DIALOG_INTERIOR_DESIGN_KEY = "scheduleAppointment";
export const DIALOG_CUSTOM_WINDOW_KEY = "window-consultation-modal";
export const DIALOG_REQUEST_CONSULTATION_KEY = "request-consultation-modal";
export const DIALOG_COOKIE_MANAGEMENT_KEY = "cookie-management-modal";
export const SPACES_WISTIA_ID = "ofe6qvnj8g";
